<template>
  <div
    id="sala-header"
  >
    <v-row>
        <v-col>
          <h2>Sala do Empreendedor - Administração</h2>
        </v-col>
    </v-row>

      <v-row>
        <v-col>
          <v-bottom-navigation
            :value="activeBtn"
            color="primary"
          >
            <v-divider
              vertical
            ></v-divider>

            <v-btn
              :to="'/sala-principal/' + cityId + '/sala-indicadores'"
            >
              <span>Indicadores</span>
            </v-btn>

            <v-divider
              vertical
            ></v-divider>

            <v-btn
              :to="'/sala-principal/' + cityId + '/sala-indicadores-apuracao'"
            >
              <span>Formas de Apuração</span>
            </v-btn>
            <v-divider
              vertical
            ></v-divider>

            <v-btn
              :to="'/sala-principal/' + cityId + '/sala-indicadores-fonte'"
            >
              <span>Fontes</span>
            </v-btn>
            <v-divider
              vertical
            ></v-divider>

            <v-btn
              :to="'/sala-principal/' + cityId + '/sala-indicadores-leitura'"
            >
              <span>Leituras</span>
            </v-btn>
            <v-divider
              vertical
            ></v-divider>

            <v-btn
              :to="'/sala-principal/' + cityId + '/sala-indicadores-nivel'"
            >
              <span>Níveis</span>
            </v-btn>
            <v-divider
              vertical
            ></v-divider>

            <v-btn
              :to="'/sala-principal/' + cityId + '/sala-indicadores-unidade'"
            >
              <span>Unidades</span>
            </v-btn>

            <v-divider
              vertical
            ></v-divider>
          </v-bottom-navigation>
        </v-col>
      </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    payload: { type: Object }
  },
  data () {
    return {
      activeBtn: 0,
      estado: this.$store.state.uf
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isConsultorCondutorMunicipio',
      'isConsultorEspecialistaMunicipio',
      'isADMunicipio',
      'city',
      'cityId',
      'isSPFesp',
      'isSPFespEspecial',
      'isSPCoordenador'
    ])
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
